import { FC, useEffect } from 'react'
import cn from 'classnames'

import { Portal } from '@src/components/common/Portal/Portal'
import { ReactComponent as Close } from '@src/assets/close.svg'
import style from './Modal.module.scss'

type ModalPropsType = {
  close?: () => void
  isOpen: boolean
  styleModalWindow?: string
}

export const Modal: FC<ModalPropsType> = ({
  styleModalWindow, children, close, isOpen,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <>
      {isOpen && (
        <Portal>
          <div className={style.modal}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div className={style.bg} onClick={close} />
            <div className={cn(style.content, styleModalWindow)}>
              {close && (
                <button type="button" onClick={close} className={style.successModalClose}>
                  <Close />
                </button>
              )}
              {children}
            </div>
          </div>
        </Portal>
      )}
    </>
  )
}
